import { jsx as _jsx } from "react/jsx-runtime";
import { memo } from 'react';
import { TableRowStyled } from './ItemWorkflowTableRow.styled';
const ItemWorkflowTableRow = ({ index, item, context, itemContent, 
/*rowContent,*/ ...tableRowProps }) => {
    // return <TableRowStyled {...tableRowProps}>{itemContent ? itemContent(index, item, context) : rowContent(index, item, context)}</TableRowStyled>;
    return _jsx(TableRowStyled, { ...tableRowProps, children: itemContent?.(index, item, context) });
};
const ItemWorkflowTableRowMemoized = memo(ItemWorkflowTableRow, arePropsEqual);
function arePropsEqual(prevProps, nextProps) {
    return (prevProps.rowState === nextProps.rowState &&
        prevProps.selected === nextProps.selected &&
        prevProps.index === nextProps.index &&
        prevProps.item === nextProps.item &&
        prevProps.hover === nextProps.hover);
}
export { ItemWorkflowTableRowMemoized };
